module.exports = __webpack_public_path__ + "img/Sign_out.e23e40c8.svg";